<template>
	<div class="pt-5">
		<v-progress-linear v-if="loading" indeterminate color="primary" />
		<div class="produto" :class="item ? 'produto--sem-foto' : ''" v-else>
			<Imagens :imagens="imagens" :galeria="true" :desconto="retornarDesconto(this.precos)" v-if="!item" />
			<div class="produto__info">
				<div class="produto__cabecalho">
					<h1 class="produto__descricao">{{ descricaoProduto }}</h1>
					<div class="produto__precos" v-if="!produto.categorizado">
						<div class="produto__preco produto__preco--anterior" v-if="this.precos.percpromocao > 0">
							{{
								convertDinheiro(
									calculaDesconto(
										this.precos.precodinheiro,
										this.precos.percpromocao,
										this.precos.promoqtapartirde
									)
								)
							}}
						</div>
						<div class="produto__preco texto--text">
							{{ convertDinheiro(valorUnitario) }}
						</div>
					</div>
				</div>
				<ProdutoSku :skus="produto.skus" :skuSelecionado="sku" @selecionarSku="selecionarSku" />
				<div class="produto__categorias" v-if="produto.categorizado || produto.extras">
					<ProdutoCategorizado
						:categorias="produto.categorizado ? produto.tamanhos[0].categorias : produto.agregados"
						:acompanhamentosSelected="acompanhamentosSelected"
						:adicionaisSelected="adicionaisSelected"
						:contadorCategoria="contadorCategoria"
						@selecionarAdicionais="selecionarAdicionais"
						@selecionarAcompanhamentos="selecionarAcompanhamentos"
						@selecionarCategoria="selecionarCategoria"
					/>
				</div>
				<Quantidade
					:produto="produto"
					:quantidade="quantidade"
					@alterarQuantidade="alterarQuantidade"
					:saldo="produto.sku ? sku.saldo : produto.estoque"
					:quantidadeComprada="
						item
							? this.retornarQtdCompradaItem(this.produto.codigo, this.sku.sku) - item.quantidade
							: this.retornarQtdCompradaItem(this.produto.codigo, this.sku.sku)
					"
				/>
				<input
					v-if="produto.obsextra"
					v-model="observacaoItem"
					class="produto__observacao"
					placeholder="Se for necessário deixe uma observação"
					maxlength="255"
				/>
				<Botao
					:texto="desabilitarBotao() ? 'Esgotado ' : 'Comprar'"
					@clicar="comprar"
					grande
					:disabled="desabilitarBotao() || this.contadorCategoria != this.quantidadeCategorias"
				>
					<template
						v-slot:depois
						v-if="produto.categorizado || (!produto.categorizado && produto.extras.length > 0)"
					>
						{{ convertDinheiro(valorTotal) }}
					</template>
				</Botao>
			</div>
			<div class="produto__detalhes" v-if="(produto.observacao || produto.detalhes || produto.sku) && !item">
				<h2>DETALHES</h2>
				{{ produto.observacao }}
				<div v-html="produto.detalhes.replace(/\n/g, '<br />')" />
				<div class="produto__medidas" v-if="produto.sku">
					<div><strong>Altura: </strong>{{ sku.altura }}cm</div>
					<div><strong>Comprimento: </strong>{{ sku.comprimento }}cm</div>
					<div><strong>Largura: </strong>{{ sku.largura }}cm</div>
					<div><strong>Peso: </strong>{{ sku.peso }}g</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import ProdutoCategorizado from '../components/Produto/ProdutoCategorizado.vue'
import Quantidade from '../components/Produto/Quantidade.vue'
import Botao from '../components/shared/Botao.vue'
import Imagens from '../components/shared/Imagens.vue'
import ProdutoSku from '../components/Produto/ProdutoSku.vue'

export default {
	props: { item: Object },
	data: function () {
		return {
			computador: {
				cliente: {},
			},
			imgSrc: '',
			dialog: false,
			dialogQuantidade: false,
			loading: true,
			precos: [],
			variacoes: [],
			quantidade: 1,
			quantidadesSelector: ['1', '2', '3', '4', '5'],
			dialogComprarCategorizado: false,
			dialogComprarSku: false,
			produto: {},
			sku: {},
			imagemSelecionada: {},
			contadorImagem: 0,
			produtoId: '',
			observacaoItem: '',
			acompanhamentosSelected: [],
			adicionaisSelected: [],
			acompanhamentos: [],
			adicionais: [],
			contadorCategoria: 0,
			teste: 7,
		}
	},
	components: {
		Imagens,
		ProdutoCategorizado,
		Botao,
		Quantidade,
		ProdutoSku,
	},
	computed: {
		...mapGetters({
			empresa: 'empresa',
			catalogo: 'catalogo',
			cadastroProduto: 'cadastroProduto',
			cartProducts: 'cartProducts',
		}),
		descricaoProduto(){
			if(this.produto.sku){
				if(this.empresa.usarDescricaoSku == 'S')
					return this.sku.descricao
				else if(this.empresa.usarDescricaoSku == 'A')
				return this.produto.descricao + ' - ' + this.sku.descricao
			}
			return this.produto.descricao

		},
		codigoProduto() {
			return this.item ? this.item.codigo : this.$route.params.codigo
		},
		quantidadeCategorias() {
			if (this.verificarMobile()) return 0
			if (this.produto.categorizado) return this.produto.tamanhos[0].categorias.length - 1
			else if (this.produto.agregados.length > 0) return this.produto.agregados.length - 1
			else return 0
		},
		valorSabor() {
			var categorias = this.produto.tamanhos[0].categorias
			var sabor = 0
			var valor = 0
			var qtdSabores = 0

			var qtd = parseFloat(this.quantidade.toString().replace(',', '.'))

			categorias.map((categoria) => {
				if (categoria.saboresPizza == 1) {
					sabor = 1
					if (this.acompanhamentosSelected.length > 0) {
						if (this.empresa.tipo_vlpizza == 0) {
							this.acompanhamentosSelected.map((item) => {
								if (item.preco > valor && item.categoriumId == categoria.id) valor = Number(item.preco)
							})
						} else if (this.empresa.tipo_vlpizza == 1) {
							this.acompanhamentosSelected.map((item) => {
								if (item.categoriumId == categoria.id) {
									valor += Number(item.preco)
									qtdSabores++
								}
							})
							valor = qtdSabores > 0 ? valor / qtdSabores : 0
						}
					}
				}
			})

			if (sabor == 0)
				valor =
					this.calculaDesconto(
						this.precos.precodinheiro,
						this.precos.percpromocao,
						this.precos.promoqtapartirde,
						qtd
					)

			return valor
		},
		valorItem() {
			var qtd = parseFloat(this.quantidade.toString().replace(',', '.'))

			var vlTotItem = this.calculaDesconto(
				this.precos.precodinheiro,
				this.precos.percpromocao,
				this.precos.promoqtapartirde,
				qtd
			)

			if (this.produto.categorizado) {
				vlTotItem = this.valorSabor
				this.adicionaisSelected.map((extra) => {
					if (extra.quantidade) {
						vlTotItem += Number(extra.preco) * Number(extra.quantidade)
					}
				})

				this.acompanhamentosSelected.map((extra) => {
					if (extra.cobrar) {
						extra.quantidade = extra.quantidadeFixa > 0 ? extra.quantidadeFixa : 1

						vlTotItem += Number(extra.preco) * Number(extra.quantidade)
					}
				})
			}

			return `R$ ${parseFloat(vlTotItem).toFixed(2).toString().replace('.', ',')}`
		},
		imagens() {
			if (!this.loading) {
				if (this.produto.sku) {
					return this.sku.skuimagens
				} else if (this.produto.imagens.length > 0) return this.produto.imagens
				else return [{ url_img: require(`@/assets/produto.png`) }]
			} else return [{ url_img: require(`@/assets/produto.png`) }]
		},
		valorTotal() {
			let vlTotItem = 0
			if (this.produto.categorizado) {
				vlTotItem = this.valorSabor
				this.adicionaisSelected.map((extra) => {
					if (extra.quantidade) {
						vlTotItem += Number(extra.preco) * Number(extra.quantidade)
					}
				})

				this.acompanhamentosSelected.map((extra) => {
					if (extra.cobrar) {
						extra.quantidade = extra.quantidadeFixa > 0 ? extra.quantidadeFixa : 1

						vlTotItem += Number(extra.preco) * Number(extra.quantidade)
					}
				})

				return vlTotItem * this.quantidade
			} else {
				vlTotItem = Number(
					this.calculaDesconto(
						this.precos.precodinheiro,
						this.precos.percpromocao,
						this.precos.promoqtapartirde,
						parseFloat(this.quantidade)
					)
				)
				this.adicionaisSelected.map((extra) => {
					if (extra.quantidade) {
						vlTotItem += Number(extra.preco) * Number(extra.quantidade)
					}
				})
				return vlTotItem * parseFloat(this.quantidade.toString().replace(',', '.'))
			}
		},
		valorUnitario() {
			if (this.produto.categorizado) {
				return this.valorSabor
			} else {
				return this.calculaDesconto(
					this.precos.precodinheiro,
					this.precos.percpromocao,
					this.precos.promoqtapartirde,
					parseFloat(this.quantidade)
				)
			}
		},
	},
	methods: {
		...mapActions(['addToCart', 'addcadastroProduto']),
		fecharDialog() {
			this.$emit('fecharDialog')
		},
		desabilitarBotao() {
			let saldo = this.produto.sku ? this.sku.saldo : this.produto.estoque
			return this.verificarProdutoEsgotado(this.produto.codigo, saldo, this.item ? true : false, this.sku.sku, this.quantidade)
		},
		async carregarProduto() {
			try {
				this.loading = true

				if (this.cadastroProduto) this.produto = this.cadastroProduto
				else {
					const response = await this.axios.get(
						`/catalogos/${this.catalogo.id}/produto/${this.codigoProduto}`
					)

					this.produto = response.data.itens
				}

				this.precos = this.produto.precos[0]

				if (this.produto.venderfracionado) this.quantidade = '1,00'
				else this.quantidade = 1

				this.carregarAgregados()

				if (this.produto.sku) {
					let skuUrl = this.produto.skus.filter((sku) => sku.sku == this.$route.params.sku)[0]
					this.sku = skuUrl ?? this.produto.skus[0]
					if (this.sku.skuimagens.length < 1)
						this.sku.skuimagens = [{ url_img: require(`@/assets/produto.png`) }]
					this.imagemSelecionada = this.sku.skuimagens[0] ?? require(`@/assets/produto.png`)
				}
				
				this.carregarCategorizado()

				this.carregarItem()
			} catch (error) {
				//this.$router.push(`/${this.catalogo.identificadorCatalogo}`)
			} finally {
				this.loading = false
			}
		},
		carregarAgregados() {
			if (this.produto.extras) {
				this.produto.agregados = []

				var acompanhamentos = this.produto.extras.filter((p) => p.tipo == 1 || p.tipo == 3)
				var adicionais = this.produto.extras.filter((p) => p.tipo == 2 || p.tipo == 4)

				var sequencia = 1

				if (acompanhamentos.length > 0) {
					this.produto.agregados.push({
						id: sequencia,
						sequencia: sequencia,
						nome: 'ACOMPANHAMENTOS',
						minimo: 0,
						maximo: 0,
						saboresPizza: false,
						fixo: false,
						editavel: false,
						ctc_seqinterna: 0,
						extrascategorizados: acompanhamentos,
					})

					sequencia++
				}

				if (adicionais.length > 0) {
					this.produto.agregados.push({
						id: sequencia,
						sequencia: sequencia,
						nome: 'ADICIONAIS',
						minimo: 0,
						maximo: 0,
						saboresPizza: false,
						fixo: false,
						editavel: true,
						ctc_seqinterna: 0,
						extrascategorizados: adicionais,
					})
				}

				this.acompanhamentosSelected = acompanhamentos.filter((p) => p.tipo == 3)
				adicionais.map((extra) => {
					if (extra.tipo == 4) {
						extra.quantidade = extra.quantidadeFixa > 0 ? Number(extra.quantidadeFixa) : 1
						this.adicionaisSelected.push(extra)
					}
				})
			}
		},
		carregarCategorizado() {
			if (this.produto.categorizado) {
				Object.assign(this.adicionais, this.produto.tamanhos[0].categorias[0].extrascategorizados)
				Object.assign(this.acompanhamentos, this.produto.tamanhos[0])

				this.produto.tamanhos[0].categorias.map((categoria) => {
					categoria.extrascategorizados.map((extra) => {
						if (categoria.editavel == 0 && extra.cobrar == 1) {
							extra.quantidade = extra.quantidadeFixa > 0 ? extra.quantidadeFixa : 1
						}
					})
				})

				if (this.produto.tamanhos[0]) {
					var categoria = this.produto.tamanhos[0].categorias

					categoria.map((categoria) => {
						if (categoria.fixo) {
							categoria.extrascategorizados.map((extra) => {
								if (extra.cobrar) {
									extra.quantidade = extra.quantidadeFixa > 0 ? Number(extra.quantidadeFixa) : 1
									this.adicionaisSelected.push(extra)
								} else {
									this.acompanhamentosSelected.push(extra)
								}
							})
						}
					})
				}
			}
		},
		carregarItem() {
			if (this.item) {
				this.quantidade = this.produto.venderfracionado
					? parseFloat(this.item.quantidade).toFixed(2).toString().replace('.', ',')
					: this.item.quantidade
				this.observacaoItem = this.item.observacao

				this.acompanhamentosSelected = this.item.extras.filter((p) => !p.quantidade)
				this.adicionaisSelected = this.item.extras.filter((p) => p.quantidade)
				if (this.produto.sku) this.selecionarSku(this.item.skuSelecionado)

				if (this.produto.categorizado) {
					this.acompanhamentosSelected = []
					this.adicionaisSelected = []
					this.produto.tamanhos[0].categorias.map((categoria) => {
						if (categoria.editavel == 0) {
							this.item.extras.map((extra) => {
								if (extra.categoriumId == categoria.id) {
									this.acompanhamentosSelected.push(extra)
								}
							})
						} else {
							this.item.extras.map((extra) => {
								if (extra.categoriumId == categoria.id) {
									if (extra.cobrar) this.adicionaisSelected.push(extra)
									else this.acompanhamentosSelected.push(extra)
								}
							})
						}
					})
				}
			}
		},
		verificarQuantidadeCategoria(categoria) {
			let quantidade = 0

			if (categoria.minimo == 0 && categoria.maximo == 0) return true
			else {
				this.adicionaisSelected.map((item) => {
					if (item.categoriumId == categoria.id) quantidade = quantidade + item.quantidade
				})
				this.acompanhamentosSelected.map((item) => {
					if (item.categoriumId == categoria.id) quantidade++
				})

				if (quantidade >= categoria.minimo && quantidade <= categoria.maximo) return true
				else if (quantidade < categoria.minimo)
					if (categoria.minimo == 1) {
						this.$store.dispatch(
							'showError',
							`É obrigatório selecionar no mínimo ${categoria.minimo} item em ${categoria.nome}!`
						)
						return false
					} else {
						this.$store.dispatch(
							'showError',
							`É obrigatório selecionar no mínimo ${categoria.minimo} itens em ${categoria.nome}!`
						)
						return false
					}
				else if (quantidade > categoria.maximo)
					if (categoria.maximo == 1) {
						this.$store.dispatch(
							'showError',
							`É permitido selecionar no máximo ${categoria.maximo} item em ${categoria.nome}!`
						)
						return false
					} else {
						this.$store.dispatch(
							'showError',
							`É permitido selecionar no máximo ${categoria.maximo} itens em ${categoria.nome}!`
						)
						return false
					}
			}
		},
		validarQuantidade() {
			if (
				!parseFloat(this.quantidade.toString().replace(',', '.')) ||
				parseFloat(this.quantidade.toString().replace(',', '.')) <= 0
			) {
				this.$store.dispatch('showError', 'A quantidade precisa ser maior que zero!')
				return false
			} else return true
		},
		validarValorUnitario() {
			if (!this.valorUnitario > 0) {
				this.$store.dispatch('showError', 'Não há valor lançado!')
				return false
			} else return true
		},
		validarCategorias() {
			if (!this.produto.categorizado) return true

			let quantidadeValidada = false
			for (var i = 0; i < this.produto.tamanhos[0].categorias.length; i++) {
				this.verificarQuantidadeCategoria(this.produto.tamanhos[0].categorias[i])
				quantidadeValidada = this.verificarQuantidadeCategoria(this.produto.tamanhos[0].categorias[i])
				if (!quantidadeValidada) break
			}
			return quantidadeValidada
		},
		comprar() {
			if (!this.validarQuantidade()) return

			if (!this.validarValorUnitario()) return

			if (!this.validarCategorias()) return

			let extras = []

			this.acompanhamentosSelected.map(function (item) {
				extras.push(item)
			})

			this.adicionaisSelected.map(function (item) {
				extras.push(item)
			})

			let cart = {
				uuid: this.item ? this.item.uuid : '',
				codigo: this.produto.codigo,
				descricao: this.descricaoProduto,
				categorizado: this.produto.categorizado,
				quantidade: parseFloat(this.quantidade.toString().replace(',', '.')),
				observacao: this.observacaoItem,
				valorUnitario: this.valorUnitario,
				valorTotal: this.valorTotal,
				imagem: this.imagens[0].url_img,
				operacao: this.item ? 'ALTER_ITEM_CART' : 'ADD_TO_CART',
				id: this.produto.id,
				skuSelecionado: this.sku,
				cadastroProduto: this.produto,
				extras: extras,
			}
			this.addToCart(cart)

			if (this.$router.history.current.name !== 'Checkout')
				this.$router.push(`/${this.catalogo.identificadorCatalogo}${this.retornarQueryVendedor()}`)
			else this.fecharDialog()

			this.addcadastroProduto({})
		},

		alterarQuantidade(quantidade) {
			this.quantidade = quantidade
		},

		selecionarSku(sku) {
			this.sku = sku
			if (!this.item) this.quantidade = this.produto.venderfracionado ? '1,00' : 1

			//window.history.pushState({}, null, this.$route.path + '/' + sku.sku)
			this.contadorImagem = 0
			this.imagemSelecionada = sku.skuimagens[0]
		},
		selecionarImagem(i) {
			this.contadorImagem = i
		},
		selecionarAdicionais(adicionais) {
			this.adicionaisSelected = adicionais
		},
		selecionarAcompanhamentos(acompanhamentos) {
			this.acompanhamentosSelected = acompanhamentos
		},
		selecionarCategoria(categoriaSelecionada) {
			this.contadorCategoria = categoriaSelecionada
		},
	},
	watch: {
		item() {
			if (this.item.uuid) {
				this.carregarProduto()
			}
		},
	},
	async created() {
		//document.title = 'this.produto.descricao'
		await this.carregarProduto()
	},
}
</script>
<style scoped>
* {
	margin: 0 auto;
}

ul,
li {
	list-style-type: none;
	margin: 0;
	padding: 0;
}

.produto {
	max-width: 63rem;
	display: grid;
	grid-template-columns: 50% 50%;
}

.produto--sem-foto {
	max-width: 31.5rem;
}

.produto__info {
	width: 100%;
	text-align: start;
	padding-left: 10px;
	margin: 0;
}

.produto--sem-foto .produto__info {
	padding: 0;
	grid-column-start: 1;
	grid-column-end: 3;
}

.produto__cabecalho {
	margin-bottom: 1rem;
}

.produto__descricao {
	font-weight: 900;
	font-size: 30px;
	text-transform: uppercase;
	color: var(--v-primary-base);
}

.produto__precos {
	display: flex;
	gap: 1rem;
}

.produto__preco {
	font-size: 24px;
	font-weight: bold;
	margin: 0px;
}

.produto__preco--anterior {
	color: gray;
	text-decoration: line-through;
}

input:focus {
	outline: none;
}

.produto__observacao {
	border: 2px solid #6d6767;
	width: 100%;
	height: 3.7rem;
	border-radius: 13px;
	padding: 1rem;
	margin-bottom: 1rem;
	background-color: white;
}

.produto__detalhes {
	border-radius: 13px;
	background-color: #d9d9d9;
	padding: 1rem;
	margin-top: 1rem;
	text-align: justify;
	text-justify: inter-word;
	grid-column-start: 1;
	grid-column-end: 3;
	grid-row-start: 2;
	width: 100%;
}

.produto__medidas {
	display: flex;
	flex-wrap: wrap;
	gap: 1rem;
	margin-top: 1rem;
}

.produto__medidas div {
	margin: 0;
}

::-webkit-scrollbar {
	height: 0.5em;
	width: 0.5em;
}

::-webkit-scrollbar-track {
	background: #d9d9d9;
	border-radius: 100vw;
}

::-webkit-scrollbar-thumb {
	background: #6d6767;
	border-radius: 100vw;
}

::-webkit-scrollbar-thumb:hover {
	background: var(--v-primary-base);
}

@media (max-width: 600px) {
	.produto {
		width: 90%;
		display: flex;
		flex-direction: column;
	}
	.produto__imagens {
		width: 100%;
	}

	.produto__galeria {
		display: none;
	}

	.produto__info {
		width: 100%;
		padding: 0;
	}

	/* .produto_cabecalho{
		background-color: white;
		position:sticky;
		top: 50px;
		z-index: 100;
	} */

	.produto__paginacao {
		display: flex;
	}

	.produto__detalhes {
		margin-top: 1rem;
	}

	.produto__categorias {
		height: auto;
		padding-right: 0;
	}
}
</style>